import { OnlineSales } from 'gw-edge-client';
import { useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { type MissingInformationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/missingInformation';
import { missingInformationAtom } from '../atoms/missingInformationAtom';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export function useUpdateMissingInformation(goNext: () => void): {
    isWaiting: boolean;
    updateMissingInformation: (missingInformation: MissingInformationDTO) => Promise<void>;
} {
    const [isWaiting, setIsWaiting] = useState(false);
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const setMissingInformation = useSetRecoilState(missingInformationAtom);

    const updateMissingInformation = async (
        missingInformation: MissingInformationDTO
    ): Promise<void> => {
        setIsWaiting(true);

        await OnlineSales.updateMissingInformation(jobNumber, sessionId, missingInformation).then(
            (response) => {
                setMissingInformation(response);
                setIsWaiting(false);
                goNext();
            }
        );
    };

    return { isWaiting, updateMissingInformation };
}
